import { useTradeSocket } from "@/hooks/use-trade-socket";

const TradeSocketListener = () => {
  useTradeSocket();
  return null;
};

export default TradeSocketListener;
